export const TEST = 'TEST'


// WEBPACK FOOTER //
// ./src/store/modules/listReload/constant.js